import { useMutation, useQueryClient } from "@tanstack/react-query";
import { applicationForLeaveApi } from "../../../../../services/human-organization/application-for-leave.service";
import { notification } from "antd";

export const useCreateAFL = () => {
  const queryClient = useQueryClient();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: (body: any) => {
      const request = applicationForLeaveApi.toRequest(body);
      return applicationForLeaveApi.create(request);
    },
  });

  const createApplicationForLeave = (
    body: any,
    options?: { onSuccess?: (res: any) => void }
  ) => {
    mutate(body, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({ queryKey: ["AFL-requests"] });
        notification.success({
          message: "Thành công!",
          description: `Tạo yêu cầu thành công.`,
        });
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: `Tạo yêu cầu thất bại.`,
        });
      },
    });
  };
  return { mutate, createApplicationForLeave, ...restMutation };
};
